import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CssBaseline, Box } from "@mui/material";
import { HomePage } from "./pages/HomePage.tsx";
import { PrivacyPage } from "./pages/PrivacyPage.tsx";
import { TermsPage } from "./pages/TermsPage.tsx";
import { AdminDashboardPage } from "./pages/AdminDashboardPage.tsx";
import { CustomerPortalPage } from "./pages/CustomerPortalPage.tsx";
import { LoginPage } from "./pages/LoginPage.tsx";
import { AuthProvider } from "./auth/AuthContext.tsx";
import { ProtectedRoute } from "./auth/ProtectedRoute.tsx";
import { Layout } from "./components/Layout.tsx";
import { BookingDialog } from "./components/BookingDialog.tsx";
import emailjs from "@emailjs/browser";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { ThemeProvider } from "./contexts/ThemeContext.tsx";
import { useThemeContext } from "./contexts/ThemeContext.tsx";
import { getTheme } from "./theme.ts";

// Create a wrapper component that uses the theme context
const ThemedApp = () => {
  const { mode } = useThemeContext();
  const theme = getTheme(mode);
  const [openDialog, setOpenDialog] = useState(false);

  const handleOpenBookingDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseBookingDialog = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    // Update the body background color when theme changes
    document.body.style.backgroundColor = theme.palette.background.default;
  }, [mode, theme.palette.background.default]);

  return (
    <MuiThemeProvider theme={theme}>
      <Box sx={{ minHeight: "100vh", backgroundColor: "background.default" }}>
        <Router>
          <CssBaseline />
          <Routes>
            <Route
              path="/"
              element={<Layout onOpenBookingDialog={handleOpenBookingDialog} />}
            >
              <Route
                index
                element={
                  <HomePage onOpenBookingDialog={handleOpenBookingDialog} />
                }
              />
              <Route path="algemene-voorwaarden" element={<TermsPage />} />
              <Route path="inloggen" element={<LoginPage />} />
              <Route path="beheer" element={<ProtectedRoute requiredRole="admin"><AdminDashboardPage /></ProtectedRoute>} />
              <Route path="mijn-pippaya" element={<ProtectedRoute requiredRole="customer"><CustomerPortalPage /></ProtectedRoute>} />
            </Route>
          </Routes>

          {/* Booking Dialog */}
          <BookingDialog open={openDialog} onClose={handleCloseBookingDialog} />
        </Router>
      </Box>
    </MuiThemeProvider>
  );
};

function App() {
  useEffect(() => {
    emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY!);
  }, []);

  return (
    <ThemeProvider>
      <AuthProvider>
        <ThemedApp />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
